import React, { PureComponent } from 'react';
import { pluralHelper } from '../../../../helpers/stringutils';
import { connect } from 'react-redux';
import UserSvg from '../../../shared/UI/userSvg';
import TravellerPanel from '../../../shared/traveller-panel';


class PaxButton extends PureComponent {

    constructor(props){
        super(props);
        this.state = {
            isOpen:false,
        }
        this.togglePaxPanel = this.togglePaxPanel.bind(this);
        this.documentClickHandler = this.documentClickHandler.bind(this);
    }

    componentDidMount(){
        document.body.addEventListener('click', this.documentClickHandler);
    }

    componentWillUnmount(){
        document.body.removeEventListener('click', this.documentClickHandler);
    }


    documentClickHandler(e){
        try{
            if(this.state.isOpen){
                if(e.target.offsetParent.className !== "pax-button-panel"){
                    this.setState({isOpen:false});
                } 
            }
          }catch(e){}
    }

    togglePaxPanel(){
        this.setState({isOpen: !this.state.isOpen});
    }

    render(){

        const { paxNumber, clazz, isShare, status } = this.props;
        const { isOpen } = this.state;

        return(
            <div className={`relative ${clazz || ""}`}>
                <button type="button" className={`rounded-svg-btn paxButton full-width-mobile mb2 ${(isShare || status === 'confirmed') ? 'no-pointer-event' : ''}`} onClick={ (!isShare || status !== 'confirmed') ? this.togglePaxPanel : null}>
                    <UserSvg clazz={"user inline-block mr1"}/>
                    {paxNumber} {pluralHelper("Adult", paxNumber)}
                    {
                        (!isShare && status !== 'confirmed') && (
                            <svg xmlns="http://www.w3.org/2000/svg" height="9" width="16" className={`ml1 arrow ${isOpen ? 'active' : ''}`}>  
                                <path fill="#3D3D3D" fillRule="evenodd" d="M7.578 9.345L.233 2.06a.596.596 0 0 1 0-.844l.983-.983a.596.596 0 0 1 .844 0L8 6.114l5.94-5.88a.596.596 0 0 1 .844 0l.983.982a.596.596 0 0 1 0 .844L8.422 9.345a.596.596 0 0 1-.844 0z"/>
                            </svg>
                        )
                    }
                </button>
                
                {
                    isOpen && <div className="pax-button-panel"><TravellerPanel /></div>
                }
            </div>
        )
    }
}


const mapStateToProps = state => {
    return{
        status:(state.currentBooking.status !== undefined) ? state.currentBooking.status : "",
        paxNumber:(state.currentBooking.passengers !== undefined) ? state.currentBooking.passengers.length : 0
    }
}

export default connect(mapStateToProps, null)(PaxButton);